/**
 * navigation module.
 * @module navigation
 */

import 'js-cookie';
import 'libs/jquery.navgoco.min.js';

$('.sidebar .nav').navgoco({
  caretHtml: false,
  accordion: true
});
